<template>
    <div>
        <div
            class="mb-2"
            style="width: fit-content"
            v-tooltip="{
                content: `<div class='m-userStores__contactHeader'>PIN rejestracyjny:</div>
                    <div class='text text-dark'>${pin || '-'}</div>`
            }"
        >
            <div class="m-userStores__contactHeader">ID lokalizacji</div>
            {{ location_id || '-' }}
        </div>
        <div class="mb-2">
            <div class="m-userStores__contactHeader">ID CRM</div>
            {{ getCrmId(location_id) || '-' }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        location_id: {
            type: Number,
            required: true
        },
        pin: {
            type: String,
            required: false
        }
    },
    methods: {
        getCrmId(id) {
            const locationData = this.$store.getters.getMerchants.filter(
                el => el.location_id === id
            )[0]
            return locationData ? locationData.crm_id : null
        }
    }
}
</script>
